import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowRight, ArrowLeft } from 'lucide-react';
import Button from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';

const SubscriptionCancelPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Auto redirect to subscription page after countdown
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/subscription/pending');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 pb-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-10 h-10 text-yellow-600" />
            </div>

            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              {t('subscription.paymentCanceled') || 'Payment Canceled'}
            </h1>

            <p className="text-gray-600 dark:text-gray-400 mb-6">
              {t('subscription.paymentCanceledMessage') || 'Your payment was canceled. No charges were made to your account.'}
            </p>

            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 mb-6">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {t('subscription.redirectingIn') || 'Redirecting in'} {countdown} {t('subscription.seconds') || 'seconds'}...
              </p>
            </div>

            <div className="space-y-3">
              <Button
                className="w-full"
                onClick={() => navigate('/subscription/pending')}
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                {t('subscription.tryAgain') || 'Try Again'}
              </Button>

            </div>

            <p className="text-sm text-gray-500 dark:text-gray-400 mt-6">
              {t('subscription.needHelp') || 'Need help?'}{' '}
              <a href="mailto:support@devskin.com" className="text-primary-600 hover:underline">
                {t('subscription.contactSupport') || 'Contact Support'}
              </a>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SubscriptionCancelPage;
